import { render, staticRenderFns } from "./BillProduct.vue?vue&type=template&id=080e65a4"
import script from "./BillProduct.vue?vue&type=script&lang=js"
export * from "./BillProduct.vue?vue&type=script&lang=js"
import style0 from "./BillProduct.vue?vue&type=style&index=0&id=080e65a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports